import {createTheme, Theme} from '@mui/material/styles';
import baseTheme from '../Ui/themes/base.ts';
import {mergeDeep} from '../../lib/merge';

export type MuiBackgroundProp = {
    paper?: string;
    menu?: string;
};

export const dashboardTheme = createTheme(
    mergeDeep({}, baseTheme, {
        palette: {
            mode: 'light',
            primary: {
                main: '#03A9F4',
                contrastText: '#FFFFFF',
            },
            background: {
                default: '#F2F7FE',
                paper: '#FFFFFF',
                menu: '#01013C',
            } as MuiBackgroundProp,
            secondary: {
                main: '#01013C',
            },
            error: {
                main: '#E53935',
            },
            warning: {
                main: '#FB8C00',
            },
            success: {
                main: '#81d516',
            },
            divider: 'rgba(133,133,133,0.12)',
            text: {
                secondary: `rgba(0, 0, 0, 0.6)`,
                disabled: '#868686',
                primary: '#000000',
            },
            common: {
                white: '#FFFFFF',
            },
        },
        shape: {
            borderRadius: 8,
        },
        typography: {
            fontFamily: 'Poppins',
            h1: {
                fontSize: 26,
                fontWeight: 100,
                marginBottom: 16,
            },
            h2: {
                fontSize: 20,
                fontWeight: 600,
                marginBottom: 16,
            },
            h3: {
                fontSize: 17,
                fontWeight: 700,
                marginBottom: 16,
            },
            h5: {
                fontSize: '1.5rem',
                fontWeight: 400,
                marginBottom: 16,
            },
            body2: {
                fontSize: '16px',
                color: 'rgba(0, 0, 0, 0.6)',
            },
        },
        components: {
            MuiCard: {
                defaultProps: {
                    elevation: 1,
                },
            },
            MuiDrawer: {
                defaultProps: {
                    elevation: 1,
                },
            },
            MuiPaper: {
                defaultProps: {
                    elevation: 1,
                },
            },
            MuiAlert: {
                styleOverrides: {
                    root: ({theme}: {theme: Theme}) => ({
                        '&:has(> .MuiAlert-action .MuiButton-root)': {
                            'alignItems': 'center',
                            '& > .MuiAlert-action': {
                                paddingTop: 0,
                            },
                            [theme.breakpoints.down('sm')]: {
                                'flexWrap': 'wrap',
                                '& > .MuiAlert-message': {
                                    flex: '1 1 0',
                                },
                                '& > .MuiAlert-action': {
                                    width: '100%',
                                    margin: 0,
                                    padding: theme.spacing(0, 0, 1),
                                    justifyContent: 'flex-end',
                                },
                            },
                        },
                    }),
                },
            },
            MuiDialogActions: {
                styleOverrides: {
                    root: ({theme}: {theme: Theme}) => ({
                        'flexWrap': 'wrap',
                        'gap': theme.spacing(1),
                        '& > :not(style) ~ :not(style)': {
                            marginLeft: 0,
                        },
                    }),
                },
            },
            MuiTabs: {
                defaultProps: {
                    variant: 'scrollable',
                    scrollButtons: 'auto',
                    allowScrollButtonsMobile: true,
                },
            },
            MuiInputBase: {
                styleOverrides: {
                    root: {
                        backgroundColor: '#FFF',
                    },
                },
            },
        },
    }),
);
